export default __webpack_public_path__ + "static/climate_zones-15e627c1fa930825b3e50452b934f8fd.jpg";